// Errors pages
import Error403 from './403'
import Error404 from './404'

export default {
  Error403,
  Error404
}